export default "__VITE_ASSET__D_LhSpPy__"